<template>
  <BaseButton
    :outline="true"
    background-colour="black"
    size="x-small"
    :class="bem()"
    to="@scroll:stravaMainScrollLatch"
  >
    <template #content>
      <span :class="bem('content')">
        <VisionIcon
          icon="chevron"
          colour="black"
          size="xx-small"
          :rotate="90"
          :class="bem('icon')"
        />
        <slot />
      </span>
    </template>
  </BaseButton>
</template>

<script setup>
const bem = useBEM('StravaShopNow')
</script>

<style lang="postcss" scoped>
.StravaShopNow {
  @apply relative block;

  &:hover {
    .StravaShopNow__icon {
      --vision-icon-fill: #fff;
    }
  }
}

.StravaShopNow__content {
  @apply flex gap-x-3;
}
</style>